/**
 * 덴탈맥스 계열 제조사 그룹 판별 유틸.
 *
 * 배경(2026-07-20 제조사 SSOT 정합): 제조사 회사 마스터가 中国 登泰美(69e89604…)로 통일되면서
 * getManufacturers가 반환하는 그룹명이 "덴탈맥스"(레거시 한글) → "登泰美"(중문)로 바뀌었다.
 * 위저드 곳곳의 `group === "덴탈맥스"` 이름 문자열 비교가 어긋나 카드검색·STM 등 분기가
 * 깨졌으므로, 판별을 이 헬퍼 한 곳으로 모은다.
 *
 * @MX:NOTE: [AUTO] 이름 문자열 매칭은 과도기 최소수정이다. 정석은 certificateCards 설정의
 *   objectIdKey("DENTALMAX_OBJECT_ID") 등 안정 키 기반 판별 — FE 제조사 칩 정리(P2)에서 전환 예정.
 */
export const DENTALMAX_GROUP_NAMES = ["덴탈맥스", "DENTALMAX", "登泰美"];

export function isDentalmaxGroup(group) {
  return DENTALMAX_GROUP_NAMES.includes(group);
}
